export default "__VITE_ASSET__Biu5x2gT__"